<template>
    <div class="materialScience">
        <div class="top">
            <img class="materialScience-img" src="../../../assets/images/degreeApplication/materialScience.png" alt="">
        </div>
        <div class="cont">
            <h1 class="cont-title">申报材料</h1>
            <div class="tips">注意：一共7项材料，按如下顺序准备好纸质材料。</div>
            <div class="cont-item">
                <div class="item-title">（一）学士学位申请登记表一份。</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/application.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/application.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（二）毕业证扫描件一份。</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/diploma1.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/diploma1.jpg'), require('../../../assets/images/degreeApplication/diploma2.jpg')]">
                    </el-image>
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/diploma2.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/diploma1.jpg'), require('../../../assets/images/degreeApplication/diploma2.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（三）英语考试如下材料之一：</div>
                <div class="item-text">1、重庆市学位英语合格证书扫描件一份（2011年及以前参加考试的毕业生无需提交此项材料，不接受申报学位学校为其他院校的成绩）；</div>
                <div class="item-text">2、高等教育自学考试本科段统考课程英语（二）成绩单扫描件或打印截图（重庆市外考生必须将成绩自行转至重庆市自考办并向我校自考办申请免试，TCL:023-62652910）；</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/englishAchievement.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/englishAchievement.jpg')]">
                    </el-image>
                </div>
                <div class="item-text">3、其它类英语考试合格证书或成绩单扫描件或扫描件（附准考证号、考试省市和年月备查）；</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/englishProgression.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/englishProgression.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（四）全国计算机等级考试（NCRE）合格证扫描件一份。（附考试时间、考试科目备查）</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/certificateConformity.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/certificateConformity.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">毕业生总成绩单如下之一：</div>
                <div class="item-text">
                    1、成教毕业生成绩总表一份；
                    <a href="http://jxjycjcx.cqjtu.edu.cn/Account/Login?ReturnUrl=%2f" target="_blank">
                        <span class="color-blue">（成绩查询）</span>
                    </a>
                    </div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/cjchengji.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/cjchengji.jpg')]">
                    </el-image>
                </div>
                <div class="item-text">2、自考毕业生成绩总表一份，成绩单扫描件需加盖鲜章(成绩单原件在档案袋里，由档案保存单位盖鲜章，例如档案在人才交流市场由该单位盖鲜章)。</div>
                <div class="imgs">
                    <el-image
                        class="img"
                        :src="require('../../../assets/images/degreeApplication/schoolReport.jpg')"
                        fit="contain"
                        :preview-src-list="[require('../../../assets/images/degreeApplication/schoolReport.jpg')]">
                    </el-image>
                </div>
            </div>
            <div class="cont-item">
                <div class="item-title">（六）身份证复印件一份。</div>
            </div>
            <div class="cont-item">
                <div class="item-title">（七）纸质小二寸照片2张（姓名及身份证号写背面），</div>
                <div class="item-tips">
                    <p>注意：</p>
                    <p>
                        1、纸质小2寸照片，必须与本科毕业证照片一致。（
                        <span class="color-red">毕业证照片可在</span>
                        <a href="https://www.chsi.com.cn/" target="_blank">
                            <span class="color-blue">学信网</span>
                        </a>
                        <span class="color-red">上截取</span>
                        ）
                    </p>
                    <p>2、电子照片（必须命名为  张 三 513132199210121028.jpg），
                        <span class="color-red">电子照片大小为10一40KB且像素尺寸为（宽）480*（高）640，图片必须用jpg格式</span>。电子照片在网上申报时提交。</p>
                    <p>3、申请学位所需电子照片格式不符合要求者，将无法完成学位信息网上报送工作！</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'materialScience',
}
</script>

<style lang="scss" coped>
.materialScience{
    padding: 20px;
    .top{
        .materialScience-img{
            width: 150px;
            height: 100px;
            object-fit: contain;
        }
    }
    .cont{
        margin-top: 20px;
        .tips{
            font-size: 18px;
            color: red;
            font-weight: 700;
        }
        .cont-item{
            margin-top: 10px;
            font-size: 16px;
            .item-tips{
                padding-left: 40px;
            }
            .imgs{
                margin-top: 10px;
                // display: flex;
                // flex-direction: column;
                .img{
                    width: 300px;
                    margin-right: 10px;
                    margin-bottom: 10px;
                }
            }
            .color-red{
                color: rgb(255, 0, 0);
            }
            .color-blue{
                color: #006dcc;
            }
            a:visited {
                color: #006dcc;
            }
            a:active, a:hover {
                color: #33a0ff;
            }
        }
    }
}
</style>
